<script lang="ts">
  import Modal from '$components/elements/Modal.svelte';
  import { youtubeModal } from '$lib/stores';
</script>

<Modal
  showModal={$youtubeModal !== undefined}
  onClose={() => {
    youtubeModal.set(undefined);
  }}
  overlayOnMobile
  width="fit-content"
  floatingCloseButtonColor="#fff"
>
  <iframe
    src="https://www.youtube.com/embed/{$youtubeModal}"
    title="YouTube video player"
    frameborder="0"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
    allowfullscreen
    class="youtube"
  />
</Modal>

<style lang="scss">
  .youtube {
    width: 56vw;
    height: 31.5vw;
    margin: 32px;
  }
  @include mobile {
    .youtube {
      width: calc(90vw - 32px);
      height: calc(9 * (90vw - 32px) / 16);
      margin: 16px;
    }
  }
</style>
